import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useLicensedProductsQueryForGlobalAppShortcutsQuery from './hooks/__generated__/useLicensedProductsQueryForGlobalAppShortcutsQuery.graphql.ts';
import type {
	useLicensedProductsQueryForGlobalAppShortcutsQuery$data,
	useLicensedProductsQueryForGlobalAppShortcutsQuery$variables,
} from './hooks/__generated__/useLicensedProductsQueryForGlobalAppShortcutsQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export async function preloadGlobalAppShortcutsLicensedProducts(): Promise<{
	data: useLicensedProductsQueryForGlobalAppShortcutsQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<
		useLicensedProductsQueryForGlobalAppShortcutsQuery$data,
		useLicensedProductsQueryForGlobalAppShortcutsQuery$variables
	>({
		query: useLicensedProductsQueryForGlobalAppShortcutsQuery,
	});
}
